import { CLIENTS } from "../data/site";

const Logo = ({ client }) => (
  <div
    data-testid={`client-logo-${client.id}`}
    className="group flex items-center justify-center h-16 px-10 sm:px-14 shrink-0 select-none"
  >
    {client.logo ? (
      <img
        src={client.logo}
        alt={`${client.name} logo`}
        loading="lazy"
        className="h-9 sm:h-11 w-auto max-w-[160px] object-contain grayscale opacity-55 group-hover:grayscale-0 group-hover:opacity-100 transition-[opacity,filter] duration-300"
      />
    ) : (
      <span className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-wide text-zinc-500 whitespace-nowrap group-hover:text-white transition-colors duration-300">
        {client.name}
      </span>
    )}
  </div>
);

const Strip = () => (
  <div className="flex items-center shrink-0">
    {CLIENTS.map((c) => <Logo key={c.id} client={c} />)}
  </div>
);

export default function Clients() {
  return (
    <section data-testid="clients-strip" className="bg-[#0A0A0A] py-10 sm:py-12 border-b border-white/5">
      <div className="container-x mb-6 flex items-center gap-4">
        <span className="font-tech text-[10px] uppercase tracking-[0.3em] text-[#FF6B00] whitespace-nowrap">Trusted by Melbourne businesses</span>
        <span className="h-px flex-1 bg-gradient-to-r from-[#FF6B00]/50 to-transparent" />
      </div>
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10" />
        <div className="marquee-track clients-track">
          <Strip />
          <Strip />
        </div>
      </div>
    </section>
  );
}
